// src/components/admin/payroll/PayrollList.js
import React from 'react';
import { Download, Eye, CheckCircle } from 'lucide-react';

const PayrollList = ({ records = [], onApprove }) => {
    return (
        <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-6 py-4 border-b">
                <h2 className="text-lg font-semibold">Payroll Records</h2>
            </div>
            <table className="min-w-full">
                <thead className="bg-gray-50">
                <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Employee</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Gross Salary</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Deductions</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Net Salary</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                {records.map((record) => (
                    <tr key={record.id}>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div>
                                <p className="text-sm font-medium">{record.employee_name}</p>
                                <p className="text-xs text-gray-500">{record.employee_code}</p>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                            ${record.gross_salary?.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-red-600">
                            -${record.total_deductions?.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold">
                            ${record.net_salary?.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    record.status === 'paid' ? 'bg-green-100 text-green-800' :
                        record.status === 'approved' ? 'bg-blue-100 text-blue-800' :
                            record.status === 'draft' ? 'bg-gray-100 text-gray-800' :
                                'bg-yellow-100 text-yellow-800'
                }`}>
                  {record.status}
                </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                            <div className="flex gap-2">
                                <button className="text-blue-600 hover:text-blue-900">
                                    <Eye className="w-4 h-4" />
                                </button>
                                {record.status === 'draft' && (
                                    <button
                                        onClick={() => onApprove(record.id)}
                                        className="text-green-600 hover:text-green-900"
                                    >
                                        <CheckCircle className="w-4 h-4" />
                                    </button>
                                )}
                                <button className="text-gray-600 hover:text-gray-900">
                                    <Download className="w-4 h-4" />
                                </button>
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default PayrollList;